
export default function HotelOverview() {
  return (
    <section id="hotel" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Hotel Jardín Tecina
          </h2>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Położony w Playa de Santiago, na słonecznym południowym wybrzeżu La Gomery, nasz hotel oferuje wyjątkowe połączenie natury i autentycznych kanaryjskich doświadczeń. Od spektakularnych widoków na ocean po ekskluzywne udogodnienia – każdy szczegół został zaprojektowany z myślą o komforcie naszych gości...
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="relative h-96 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/Ps5uYO3.jpg" 
              alt="Strefy wspólne hotelu" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative h-96 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/vC4NS8A.jpg" 
              alt="Wnętrza hotelu" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-stone-50 p-8 rounded-lg">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mb-4">
              <i className="ri-plant-line text-green-700 text-xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Ogród Botaniczny</h3>
            <p className="text-stone-600 leading-relaxed">
              70 000 m² ogrodu botanicznego subtropikalnego, ponad 50 gatunków roślin tworzących naturalny raj.
            </p>
          </div>

          <div className="bg-stone-50 p-8 rounded-lg">
            <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-4">
              <i className="ri-eye-line text-blue-700 text-xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Panoramiczne Widoki</h3>
            <p className="text-stone-600 leading-relaxed">
              Spektakularne widoki na Atlantyk i wyspę Tenerife z większości części hotelu.
            </p>
          </div>

          <div className="bg-stone-50 p-8 rounded-lg">
            <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mb-4">
              <i className="ri-restaurant-line text-purple-700 text-xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Gastronomia</h3>
            <p className="text-stone-600 leading-relaxed">
              6 restauracji oferujących kuchnię międzynarodową i lokalne przysmaki kanaryjskie.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="relative h-80 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/EosZA4A.jpg" 
              alt="Recepcja i lobby" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative h-80 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/7R2C7Jk.jpg" 
              alt="Strefy relaksu" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Facilities Section */}
        <div className="bg-stone-50 rounded-lg p-12 mt-16">
          <h3 className="text-3xl font-light text-stone-800 text-center mb-8">
            Tysiąc rzeczy do zrobienia
          </h3>
          <p className="text-center text-stone-600 mb-12 max-w-3xl mx-auto">
            Hotel Jardín Tecina oferuje szeroki wachlarz udogodnień, aby nasi goście mogli cieszyć się pobytem i wykorzystać go w pełni:
          </p>
          
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
            <div className="flex items-start space-x-3">
              <i className="ri-water-flash-line text-teal-600 text-xl mt-1"></i>
              <span className="text-stone-700">5 Basenów</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-sun-line text-amber-600 text-xl mt-1"></i>
              <span className="text-stone-700">2 Solaria</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-restaurant-2-line text-orange-600 text-xl mt-1"></i>
              <span className="text-stone-700">6 Restauracji</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-leaf-line text-green-600 text-xl mt-1"></i>
              <span className="text-stone-700">Eco Finca 100% organiczna</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-ship-line text-cyan-600 text-xl mt-1"></i>
              <span className="text-stone-700">Beach Club Laurel</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-heart-pulse-line text-rose-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Spa</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-golf-ball-line text-green-700 text-xl mt-1"></i>
              <span className="text-stone-700">1 Pole golfowe</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-flag-line text-green-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Minigolf</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-ping-pong-line text-yellow-600 text-xl mt-1"></i>
              <span className="text-stone-700">5 Kortów tenisowych</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-basketball-line text-indigo-600 text-xl mt-1"></i>
              <span className="text-stone-700">3 Korty do padla</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-volleyball-line text-amber-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Boisko do siatkówki plażowej</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-trophy-line text-orange-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Kort do squasha</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-run-line text-red-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Centrum fitness</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-table-2 text-teal-600 text-xl mt-1"></i>
              <span className="text-stone-700">2 Stoły do tenisa stołowego</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-scissors-cut-line text-pink-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Salon piękności</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-building-line text-stone-600 text-xl mt-1"></i>
              <span className="text-stone-700">Taras AMIDI</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-football-line text-slate-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Strefa do gry w petanque</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-store-2-line text-amber-700 text-xl mt-1"></i>
              <span className="text-stone-700">1 Sklep z rękodzielnictwem</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-presentation-line text-slate-700 text-xl mt-1"></i>
              <span className="text-stone-700">3 Sale konferencyjne</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-bear-smile-line text-yellow-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Mini klub dla dzieci</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-gamepad-line text-violet-600 text-xl mt-1"></i>
              <span className="text-stone-700">1 Sala gier</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-book-open-line text-stone-700 text-xl mt-1"></i>
              <span className="text-stone-700">Biblioteka</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-charging-pile-2-line text-green-600 text-xl mt-1"></i>
              <span className="text-stone-700">Punkt ładowania samochodów elektrycznych</span>
            </div>
            <div className="flex items-start space-x-3">
              <i className="ri-parking-box-line text-slate-600 text-xl mt-1"></i>
              <span className="text-stone-700">Parking (w zależności od dostępności)</span>
            </div>
          </div>

          <div className="text-center pt-8 border-t border-stone-200">
            <p className="text-stone-700 leading-relaxed max-w-3xl mx-auto">
              Nasze doświadczenie jest naszą gwarancją, obsługa i jakość to nasze znaki rozpoznawcze, a Twoja satysfakcja jest naszą nagrodą. Przyjdź nas odwiedzić. Czekamy na Ciebie z niecierpliwością.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}